import React from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../firebase';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();

  const handlePayment = () => {
  
    window.open('https://tmdsolutions.lemonsqueezy.com/buy/cd675369-cea1-480e-b54f-01355a47ea7b', '_blank');
  };

  const handleDashboard = () => {
    window.open('https://lookerstudio.google.com/reporting/3f2eacbf-7d0c-44d6-b3a2-76aa64ef4b31', '_blank');
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <div className="dashboard-container">
      <h1>Welcome to Your Dashboard</h1>
      <div className="dashboard-buttons">
        <button onClick={handlePayment} className="dashboard-button payment">
          Payment
        </button>
        <button onClick={handleDashboard} className="dashboard-button analytics">
          Analytics Dashboard
        </button>
        <button onClick={handleLogout} className="dashboard-button logout">
          Logout
        </button>
      </div>
    </div>
  );
};

export default Dashboard; 

